<div class="col-12 md:col-6">
  <div class="card p-fluid">
    <form (ngSubmit)="search()">

      <ng-container *ngFor="let filter of filters">
        <ng-container [ngSwitch]="filter.fdef['fieldtype']">

          <ng-container *ngSwitchCase="'date'">
            <div class="field grid"
                 [ngClass]="filter.dateFilterOperator ? 'date-filter-operator':'' ">
              <label class="col-12 mb-2 md:col-2 md:mb-0">{{filter.label}}</label>
              <div class="col-6 md:col-10">
                <p-dropdown [style]="{'width':'80px'}"
                            *ngIf="filter.dateFilterOperator"
                            (onChange)="changeDateOperator(filter)"
                            [options]="dateOperators"
                            [name]="filter.field + '_operator'"
                            [(ngModel)]="filter.operator"></p-dropdown>
                <p-calendar *ngIf="!filter.minDate"
                            [yearRange]="yearRange"
                            [yearNavigator]="true"
                            [monthNavigator]="true"
                            (onSelect)="search(filter)"
                            dateFormat="dd/mm/y"
                            [selectionMode]="filter.selectedMode"
                            [name]="filter.field"
                            [(ngModel)]="filter.value"
                            [locale]="calendarLocal"></p-calendar>
                <p-calendar *ngIf="filter.minDate"
                            [yearRange]="yearRange"
                            [yearNavigator]="true"
                            [monthNavigator]="true"
                            [minDate]="filter.minDate"
                            (onSelect)="search(filter)"
                            dateFormat="dd/mm/y"
                            [selectionMode]="filter.selectedMode"
                            [name]="filter.field"
                            [(ngModel)]="filter.value"
                            [locale]="calendarLocal"></p-calendar>
              </div>
              <!--<span *ngIf="value>0">{{value*1000|date:'dd/MM/y' }}</span>-->
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'select'">
            <div class="field grid"
                 *ngIf="!filter.filterMultiple">
              <label class="col-12 mb-2 md:col-2 md:mb-0"
                     for="{{filter.field}}">{{filter.label}}</label>
              <div class="col-6 md:col-10">
                <p-dropdown [filter]="true"
                            [dataKey]="filter.value"
                            [ngClass]="{'ui-inputwrapper-filled':filter.value||filter.focused}"
                            (onFocus)="filter.focused=true;"
                            (onBlur)="filter.focused=false;"
                            (onChange)="search(filter)"
                            [options]="filter.fdef['selectOptions']"
                            [name]="filter.field"
                            [(ngModel)]="filter.value"
                ></p-dropdown>
              </div>

            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'select'">
            <div class="field grid"
                 *ngIf="filter.filterMultiple">
              <label class="col-12 mb-2 md:col-2 md:mb-0"
                     for="{{filter.field}}">{{filter.label}}</label>
              <div class="col-6 md:col-10">
                <p-multiSelect [defaultLabel]="filter.label"
                               [filter]="true"
                               [readonly]="filter.readonly"
                               [disabled]="filter.disabled"
                               [ngClass]="{'ui-inputwrapper-filled':filter.value||filter.focused}"
                               (onFocus)="filter.focused=true;"
                               (onBlur)="filter.focused=false;"
                               (onChange)="search(filter)"
                               [options]="filter.fdef['selectOptions']"
                               [name]="filter.field"
                               [(ngModel)]="filter.value"></p-multiSelect>
                <!--<label for="{{filter.field}}">{{filter.label}}</label>  -->
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'multiselect'">
            <div class="field grid"
                 *ngIf="filter.filterMultiple">
              <label class="col-12 mb-2 md:col-2 md:mb-0"
                     for="{{filter.field}}">{{filter.label}}</label>
              <div class="col-6 md:col-10">
                <p-multiSelect [defaultLabel]="filter.label"
                               [readonly]="filter.readonly"
                               [disabled]="filter.disabled"
                               [filter]="true"
                               [ngClass]="{'ui-inputwrapper-filled':filter.value||filter.focused}"
                               (onFocus)="filter.focused=true;"
                               (onBlur)="filter.focused=false;"
                               (onChange)="search(filter)"
                               [options]="filter.fdef['selectOptions']"
                               [name]="filter.field"
                               [(ngModel)]="filter.value"></p-multiSelect>
                <!--<label for="{{filter.field}}">{{filter.label}}</label>  -->
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'checkbox'">
                            <span class="md-inputfield">
                                            <p-dropdown [filter]="true"
                                                        [ngClass]="{'ui-inputwrapper-filled':filter.value||filter.focused}"
                                                        (onFocus)="filter.focused=true;"
                                                        (onBlur)="filter.focused=false;"
                                                        (onChange)="search(filter)"
                                                        [options]="[{label:'',value:false},{label:'Oui',value:'true'},{label:'Non',value:'false'}]"
                                                        [name]="filter.field"
                                                        [(ngModel)]="filter.value"
                                            ></p-dropdown>
                            <label for="{{filter.field}}">{{filter.label}}</label>
                              </span>
          </ng-container>

          <ng-container *ngSwitchCase="'href'">
            <ng-template #itemTpl
                         let-obj="obj">
              <span>{{obj.object_preview}}</span>
            </ng-template>
            <editable-field (update)="search(filter)"
                            name="object"
                            [defaultFilter]="filter.defaultFilter"
                            [itemTemplate]="itemTpl"
                            widthClass="filterSelect"
                            [allowedClass]="filter.allowedClass"
                            [searchBy]="filter.searchBy"
                            [fdef]="filter.fdef"
                            [hrefSelect]="true"
                            [object]="filter"
                            [disabled]="false"
                            [label]="filter.label"></editable-field>
          </ng-container>

          <ng-container *ngSwitchCase="'objects'">
            <ng-template #itemTpl
                         let-obj="obj">
              <span> {{obj.object_preview}}</span>
            </ng-template>
            <editable-field (update)="search(filter)"
                            name="object"
                            [defaultFilter]="filter.defaultFilter"
                            [itemTemplate]="itemTpl"
                            widthClass="filterSelect"
                            [allowedClass]="filter.allowedClass"
                            [searchBy]="filter.searchBy"
                            [fdef]="filter.fdef"
                            [hrefSelect]="true"
                            [object]="filter"
                            [disabled]="false"
                            [label]="filter.label"></editable-field>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="field grid">
              <label class="md:col-2 col-12 mb-2 md:mb-0">{{filter.label}}</label>
              <div class="col-6 md:col-10">
                <input type="text"
                       [name]="filter.field"
                       pInputText
                       [(ngModel)]="filter.value">
              </div>
            </div>

            <!-- <span class="md-inputfield" *ngIf="filter.filterStartNumber && filter.filterMaxNumber">
                <input type="text" pattern="/\d{0,2}/" [name]="filter.field" pInputText
                    [(ngModel)]="filter.value">
                <label>{{filter.label}}</label>
            </span> -->

          </ng-container>
        </ng-container>


      </ng-container>

      <div class="ui-g form-group">
        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <button type="submit"
                  icon="ui-icon-search"
                  label="Chercher"
                  pButton></button>
          <!--        <button pButton-->
          <!--                icon="ui-icon-undo"-->
          <!--                class="btn-small btn-primary"-->
          <!--                (click)="resetFilter()"-->
          <!--                title="réinitialiser les filtres"></button>-->
        </div>
      </div>
    </form>
  </div>
</div>
